import BreadcrumbsComponent from "../BreadcrumbsComponent";

export const HeaderPage = ({tite, linkList}) => {
    return(
        <div>
            <h2 className={'font-bold text-lg'}>{tite.toUpperCase()}</h2>
            <BreadcrumbsComponent linkList={linkList} />
        </div>
    )
}